import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/prospect/report_member_table.js
const MemberTableOrg = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.breakdown)
  }

  const dataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    props.memberData.forEach((data) => {
      if (data.total_billable_lead > 0) {
        tableData.push(data)
      }
    })
    return tableData
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('0')
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      formatter: dateFormatter,
      headerStyle: colWidth,
      style: colWidth,
    },
    {
      dataField: 'total_billable_lead',
      text: 'Total Prospects',
      formatter: formatNumber,
      headerStyle: colWidth,
      style: colWidth,
      align: 'right'
    },
    {
      dataField: 'total_email_credits',
      text: 'Email Enrichment Credits',
      formatter: formatNumber,
      headerStyle: colWidth,
      style: colWidth,
      align: 'right'
    },
    {
      dataField: 'total_phone_credits',
      text: 'Phone Enrichment Credits',
      formatter: formatNumber,
      headerStyle: colWidth,
      style: colWidth,
      align: 'right'
    },
    {
      dataField: 'total_credits_charged',
      text: 'Billable Credits',
      formatter: formatNumber,
      headerStyle: colWidth,
      style: colWidth,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div>
      <ReportTable
        wrapperClasses="table-member-report table-responsive"
        keyField="date"
        data={data}
        columns={columns}
        noDataIndication={dataIndication}
        hideHeader
      />
    </div>
  )
}

export default MemberTableOrg
